/* eslint-disable import/no-default-export */
import { fields as userFields } from './constants';
import messages from './messages';
import { rules } from './validation';

function getErrorMessage(field, user) {
    const isEmpty = !user[field];
    const validationRules = rules[field] ? rules[field](user) : [];
    const failedRules = isEmpty
        ? []
        : validationRules.filter(function (rule) {
              return !rule.isValid;
          });
    return failedRules.length
        ? failedRules[0].message
        : isEmpty && (messages[field] || messages.required);
}

/**
 * Return an Object with two properties: errors and isValid:
 * errors (Object): field name and error message (Example -> { email: "Required field", password: "Please enter a minimum of 5 characters" })
 * isValid (Boolean): check if registration fields has any errors
 * @param user (Object): keys can be email and/or password of type string (can handle null/undefined)
 * @param options (Object): except a fields property (Array) - validate only fields in this list
 */
function validate(_user, _options) {
    const user = _user || {};
    const options = _options || {};
    const errors = (options.fields || userFields).reduce(function (_errors, field) {
        const message = getErrorMessage(field, user);
        if (message) {
            _errors[field] = message;
        }
        return _errors;
    }, {});

    return {
        errors: errors,
        isValid: !Object.keys(errors).length,
    };
}

export default validate;
